import React from "react";
import Image from "../../../Components/Image";
import { medias } from "../../../config/Resources";
import DropDown2 from "../../../Components/DropDown/DropDown2";
import {
  HeaderMiddleSectionGoalsDrop,
  offers,
} from "../../../config/HeaderConstants";
import Text from "../../../Components/Text";
import Menu1 from "../../../config/HeaderConstants/Menus";
import MainSearch from "../../../Components/MainSearch";
import { Button, IconButton } from "@mui/material";
import { Person } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import classNames from "classnames";

const HeaderMiddleSection1 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div
      className={classNames(
        location.pathname === "/" ? "bg-transparent" : "bg-midNightBlue-1",
        "flex desktop:mt-[10px] justify-between desktop:pt-0 pt-4 3xl:px-10  px-[85px]"
      )}
    >
      <div className="3xl:max-w-[120px]">
        <Image
          className="miniDesk:w-[100px]"
          src={medias.images.header.pagelogo}
          alt={"pageLogo"}
        />
      </div>
      <div className="ml-5">
        <DropDown2
          dropIconClass={"opacity-60  "}
          title={
            <>
              <div className="flex gap-3">
                <Image
                  src={HeaderMiddleSectionGoalsDrop.logo}
                  alt="HeaderMiddleSection"
                  className="desktop:w-[16px]"
                />
                <div>
                  <Text className="text-base desktop:!text-[12px] 3xl:text-[14px] opacity-80">
                    {HeaderMiddleSectionGoalsDrop.subTitle}
                  </Text>
                  <Text className=" text-[19px] desktop:!text-[10px] 3xl:text-[12px]">
                    {HeaderMiddleSectionGoalsDrop.title}
                  </Text>
                </div>
              </div>
            </>
          }
          menu={<Menu1 />}
        />
      </div>
      <div className="w-2/5 desktop:!w-[30%] 3xl:w-[35%]">
        <MainSearch />
      </div>
      <div className="miniDesk:!ml-3 ">
        <IconButton className="!bg-white 3xl:min-w-[60px] desktop:!min-w-[40px]   3xl:!p-3 3xl:w-[30px] !min-w-[60px] 3xl:!ml-0 !ml-6 !p-4 !bg-opacity-10">
          <Image
            className="desktop:w-[20px]"
            src={medias.images.header.select}
          />
        </IconButton>
      </div>
      <div className="flex gap-6 ml-4">
        {offers.map(({ offer, title, className }: any) => {
          return (
            <div className="flex flex-col items-start gap-1 3xl:gap-[2px]">
              <div className={`px-[14px] py-[5.5px] rounded-full ${className}`}>
                <Text className=" miniDesk:!text-[8px] desktop:!text-[10px] text-[15px]  3xl:text-[12px] uppercase font-semibold">
                  {offer}
                </Text>
              </div>
              <div className="px-2 text-lg ">
                <Text className="font-medium miniDesk:!text-[8px] desktop:!text-[9px] 3xl:text-[11px] text-white">
                  {title}
                </Text>
              </div>
            </div>
          );
        })}
      </div>
      <div>
        <Button
          onClick={() => navigate("/login-signup/register")}
          variant="outlined"
          className="!border-white miniDesk:h-[40px]  gap-3 3xl:!p-3 3xl:!text-[12px] miniDesk:!text-[10px] miniDesk:!p-[10px] miniDesk:w-[70px] !capitalize !py-[16.26px] !pl-[23.21px] !pr-[17px] !text-white !rounded-[15px] !text-[18px] !f ont-bold px-5"
        >
          <Person className="!w-[23px]  miniDesk:!w-[12px]" />
          <Text className="desktop:text-[10px]">{"Login/Signup"}</Text>
        </Button>
      </div>
    </div>
  );
};

export default HeaderMiddleSection1;
